module.exports = __webpack_public_path__ + "img/zuhe1.ccc2de40.png";